import { useBilingual } from "@/lib/bilingual";

// Grounded in Forwaro's official company profile: founded Taiwan 1991,
// Dongguan factory 2006, European/American design into a post-modern style for
// the high-end market, stainless-steel base with marble / solid-wood / leather
// series, exported to Europe, the Americas, Asia and Oceania. No invented
// figures (capacity, headcount, certifications) beyond the profile.
const CompanyStory = () => {
  const b = useBilingual();

  const milestones = [
    { figure: "1991", label: b("Founded in Taiwan", "台灣創立") },
    { figure: "2006", label: b("Manufacturing in Dongguan, China", "中國東莞設廠") },
    { figure: "4", label: b("Continents served", "外銷大洲") },
  ];

  return (
    <section className="py-14 md:py-24 bg-white">
      <div className="max-w-screen-xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <p className="text-amber-700 text-xs font-semibold tracking-widest uppercase mb-3">
              {b("Our Story", "品牌故事")}
            </p>
            <h2
              className="text-3xl md:text-5xl font-bold text-stone-900 leading-tight"
              style={{ fontFamily: "var(--font-display)" }}
            >
              {b("Three decades of", "三十年")}
              <br />
              {b("modern furniture", "專注現代傢俱")}
            </h2>
          </div>

          <div className="lg:col-span-7 space-y-5 text-stone-600 text-base leading-relaxed">
            <p>
              {b(
                "Forwaro International Contemporary Furniture was established in Taiwan in 1991 and set up its manufacturing base in Dongguan, China in 2006. We adapt European and American design concepts into a post-modern style, built for the high-end market.",
                "風華國際現代傢俱於 1991 年在台灣創立，2006 年於中國東莞設立生產基地。我們融合歐美設計理念，發展出面向高端市場的後現代風格。",
              )}
            </p>
            <p>
              {b(
                "Stainless steel sits at the heart of our work, expressed through three signature lines: a natural marble series, a solid wood series, and leather seating. Novel design, a refined appearance, and dependable quality have earned recognition from customers across our markets.",
                "以不鏽鋼為基礎，我們發展出三大代表系列：天然大理石系列、實木系列與皮革椅系列。新穎的設計、精緻的外觀與可靠的品質，深受各地客戶肯定。",
              )}
            </p>
            <p>
              {b(
                "More than three decades on, Forwaro keeps growing, with modern standard workshops, a professional design team, and advanced equipment from home and abroad. Our products move toward specialization and seriation, sold across China and exported to Europe, the Americas, Asia, and Oceania.",
                "逾三十年來，風華國際持續成長，擁有現代化標準廠房、專業設計團隊，以及國內外先進生產設備。產品朝專業化、系列化發展，行銷全中國，並外銷歐洲、美洲、亞洲與大洋洲。",
              )}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-14 pt-12 border-t border-stone-100">
          {milestones.map((m) => (
            <div key={m.figure}>
              <p
                className="text-4xl md:text-5xl font-bold text-amber-700"
                style={{ fontFamily: "var(--font-display)" }}
              >
                {m.figure}
              </p>
              <p className="text-stone-500 text-sm mt-2">{m.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CompanyStory;
